import ServiceTypeRequestDmeEntity from '../../entities/dme/ServiceTypeRequestDme.Entity';
import ReferralContactEntity from '../../entities/ReferralContact.Entity';
import DmeResponseDataModel from './DmeResponse.DataModel';

export default class DmeServiceDataModel {
    serviceTypeRequestDme: ServiceTypeRequestDmeEntity;
    referringPhysician: ReferralContactEntity;
}
